/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=c8ce1538&scoped=true&"
import script from "./dialog.vue?vue&type=script&lang=ts&"
export * from "./dialog.vue?vue&type=script&lang=ts&"
import style0 from "./dialog.vue?vue&type=style&index=0&id=c8ce1538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ce1538",
  null
  
)

export default component.exports